import { Box, Icon, Image, Text, styled } from '@qcx/ui';
import { Link } from '../../../components/Link';
import { PrincipalArticle as PrincipalArticleData } from '@atreus/data';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import { route } from '../../../route';
import { safeRenderHtml } from '../../../lib/safe-render-html.lib';

interface PrincipalArticleProps {
  principalArticle: PrincipalArticleData;
}

export const PrincipalArticle = ({
  principalArticle
}: PrincipalArticleProps) => {
  return (
    <Link
      css={{
        d: 'flex'
      }}
      to={route('news-show', {
        slug: principalArticle.slug
      })}
    >
      <Box
        css={{
          d: 'flex',
          mb: '$8',
          flexDirection: 'column-reverse',
          '@md': { flexDirection: 'row' }
        }}
      >
        <Box
          css={{
            pt: '$6',
            flex: 1,
            flexCol: true,
            '@lg': {
              justifyContent: 'center'
            }
          }}
        >
          <Text
            as={'h2'}
            css={{
              mb: '$4',
              color: '$blue900',
              '@md': { w: '$80' },
              '@lg': { w: 622 }
            }}
            dangerouslySetInnerHTML={{
              __html: safeRenderHtml(principalArticle.title)
            }}
            variant={{
              '@initial': 'displayXs',
              '@lg': 'displayMd'
            }}
            weight="semibold"
          />
          <Text
            as={'h3'}
            css={{
              color: '$textMuted',
              mb: '$4',
              '@md': { w: '$80' },
              '@lg': { w: 'auto' }
            }}
            dangerouslySetInnerHTML={{
              __html: safeRenderHtml(principalArticle.subtitle)
            }}
            variant={{
              '@initial': 'md',
              '@md': 'lg'
            }}
            weight={'medium'}
          />
        </Box>
        <Box css={{ '@md': { ml: '$14' }, '@lg': { ml: '$28' } }}>
          {principalArticle.image ? (
            <StyledImage
              css={{
                h: 193,
                '@md': {
                  w: 343
                },
                '@lg': {
                  w: 487,
                  h: 274
                }
              }}
              width={343}
              height={300}
              alt={principalArticle.title}
              loading="eager"
              src={principalArticle.image}
              noAspectRatio
            />
          ) : (
            <StyledImageEmpty
              css={{
                minW: 343,
                minH: 193,
                '@lg': {
                  minW: 487,
                  minH: 274
                }
              }}
            >
              <Icon css={{ color: '$neutral700' }} icon={faImage} size="5xl" />
            </StyledImageEmpty>
          )}
        </Box>
      </Box>
    </Link>
  );
};
const StyledImage = styled(Image, {
  w: '$full',
  d: 'flex',
  '& img': {
    objectFit: 'cover',
    h: '$full'
  },
  rounded: '$4xl',
  '&:hover::after': {
    content: '',
    bg: 'linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.05) 100%)',
    rounded: 'inherit',
    position: 'absolute',
    minMaxSize: '$full',
    left: 0,
    top: 0
  }
});
const StyledImageEmpty = styled(Box, {
  bg: '$neutral50',
  w: '$full',
  '@md': {
    maxW: 280
  },
  rounded: '$4xl',
  flexCenter: true,
  aspectRatio: '1 / 0'
});
